<!-- 充值 -->
<template>
<div class='recharge'>
  <Head :goBack='true' show="" title="我的优惠券"></Head>
  <div class="recharge_kong">&nbsp;</div>
  <div class="type_tag_box">
    <ul>
      <li v-for="(item,i) in typeList" :key="i" @click="clickType(item)" :class="item.key ===activeKey?'active':''">{{item.name}}</li>
    </ul>
  </div>
  <div class="list_box">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="我也是有底线的---"
      :immediate-check="false"
      :offset="100"
      @load="onLoad"
    > 
    <ul>
      <li :class="item.status==2?'sx':''" v-for="item in dataList" :key="item.couponId">
        <div class="item_left">
          <div class="item_left_price" v-if="item.type =='1'">
            ￥
            <span class="price">
              {{item.discount}}
            </span>
          </div>
          <div class="item_left_price" v-else-if="item.type =='2'">
            ￥
            <span class="price">
              {{item.discount}}
            </span>
          </div>
          <div class="item_left_price" v-else-if="item.type =='3'">
            <span class="price">
              {{item.discount/10 }}折
            </span>
          </div>
        </div>
        <div class="item_right">
          <div class="item_right_title">
            {{item.type =='1'?' 满减券':(item.type =='2'?'立减券':'折扣券')}}
          </div>
          <div class="item_right_time">
           {{item.endDate}}过期
          </div>
          <div class="item_right_desc">
            全场所有饮品可用{{ item.type =='1'?`，满${item.orderPrice}元减${item.discount}元`:'' }}
          </div>
        </div>
        <div class="item_btn" v-if="item.status==1" @click="goHome">
          立即使用
        </div>
        <div class="item_status" v-if="item.status==2||item.status==3">
          <img :src=" item.status=='2'?require('@/assets/images/huizhangysx.png'):require('@/assets/images/huizhang.png')" alt="">
        </div>
      </li>
    </ul>
  </van-list>
  <vueToTop :size='30' :type='8' :top='50' color='#13A556' :bottom='40'></vueToTop>
  <div class="no-data" v-if="!dataList.length">
    暂无记录...
  </div>
  </div>
  <mobile-talk ref="mobile"/>
</div>
</template>

<script>
import {mapState,mapActions} from "vuex";
import { Toast  } from "vant";
import MobileTalk from "@/components/MobileTalk";
import moment from 'moment'
export default {
//import引入的组件需要注入到对象中才能使用
components: {
  mobileTalk:MobileTalk,
},
data() {
//这里存放数据
  return {
    typeList: [
      { name: "待使用", key: 1 },
      { name: "已使用", key: 3 },
      { name: "已失效", key: 2 },
    ],
    activeKey:1,
    dataList: [],
    loading: false,
    //是否加载完毕
    finished: false,
    pageNo: 1,
    pageSize: 20,
    show:true
  };
},
//监听属性 类似于data概念
computed:{
  ...mapState(['personal'])
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  ...mapActions(['getUserMoney']),
  goHome() {
    this.$router.push({name:"home"})
  },
  clickType(v) {
    this.activeKey = v.key
    this.pageNo = 1
    this.getDataList()
  },
  onLoad() {
  this.pageNo++;
  this.getDataList()
},
  // 获取套餐选项
  getDataList(){
    let data = {
      pageStart: this.pageNo,
      pageSize: this.pageSize,
      type:this.activeKey
    }
    if (this.pageNo == 1) {
      this.dataList = []
    }
    this.loading =true
    this.$api.coupon.getCouponList(data).then((res)=>{
      if(res.code==200){
        this.dataList = this.dataList.concat(res.result);
        if (res.totalPage == this.pageNo) {
          this.finished = true;
        }
        this.loading =false
        this.dataList.forEach((item) => {
          item.endDate = moment(item.endDate).format('YYYY-MM-DD')
          item.startDate = moment(item.startDate).format('YYYY-MM-DD')
        })
      }else{
        Toast(res.msg)
      }
    })
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.getDataList()
},

beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.recharge_kong{
  width: 100%;
  height: 100px;
}
.recharge{
  background-color: #f7f7f7;
  .type_tag_box{
   ul{
    display: flex;
    justify-content:space-around;
    background-color: #fff;
    padding-bottom: 4px;
    li{
      font-size: 34px;
      position: relative;
      line-height: 106px;
      color: #555555;
    }
    .active{
      color: #333333;
      font-weight: 500;
    }
    .active:after {
        content: "";
        display: inline-block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height:4px;
        background: #409eff;
    }
   }
  }
  .list_box{
    ul{
      padding: 0 30px 0 40px ;
      li{
        display: flex;
        position: relative;
        background: url('~@/assets/images/youhuiquan.png') no-repeat center center;
        background-size:100% 100% ;
        margin-top: 30px;
        .item_left{
          height: 180px;
          width: 220px;
          .item_left_price{
            width: 100%;
            color: #fff;
            font-size: 22px;
            font-weight: 600;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          } 
          .price{
            font-size: 42px;
          } 
          .item_left_time{
            text-align: center;
            color: #fff;
            font-size: 20px;
          }
        }
        .item_right{
          padding: 0 15px;
          box-sizing:border-box;
          width:calc( 100% - 220px);
          .item_right_title{
            font-size:36px;
            color: #111111;
            height: 46px;
            margin-top: 10px;
          } 
          .item_right_time {
            font-size: 24px;
            color: #999999;
            margin-bottom: 25px;
            height: 34px;
            margin-top:  5px;
          }
          .item_right_desc{
            border-top: 1px solid #f4f5f9;
            font-size: 23px;
            line-height: 50px;
            width: 100%;
            color: #747474;
            overflow:hidden; 
            text-overflow:ellipsis; 
            white-space:nowrap;
          }

        }
        .item_btn{
          position: absolute;
          right: 15px;
          top: 51px;
          color: #654725;
          border:2px solid #654725;
          border-radius: 50px;
          line-height: 50px;
          height: 50px;
          padding:0 20px;
          font-size: 26px;
          font-weight: 600;
        }
        .item_status{
          position: absolute;
          right: 15px;
          top: 20px;
          height: 50px;
          img{
            max-height: 90px;
          }
        }
      }
      .sx{
        background: url('~@/assets/images/youhuiquanysx.png') no-repeat center center;
        background-size:100% 100% ;
      }
    }
  }
  .no-data{
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 30px;
  }
}
</style>